export enum TrackingFlowTypeEnum {
  POWER = "power",
  STANDRARD = "standard",
  PARTNER = "partner",
  TrackAndTrace = "trackAndTrace",
}
